<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="point-terms-of-service">
      <Title jpn="Conditions d'utilisation des pièces" />
      <div class="scroll-container">
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Les présentes conditions d'utilisation (ci-après dénommées les « Conditions d'utilisation de Coin ») définissent les conditions d'utilisation de « Coin » (défini ci-dessous) sur
              <a href="https://gtchaxonline.com/" target="_blank" >https://gtchaxonline.com/</a>
              (ci-après dénommé le « Service ») fourni par Xero Place Co., Ltd. (ci-après dénommée la « Société »).</span>
            <span class="text">Veuillez lire attentivement les conditions d'utilisation de Coin avant d'envisager d'acheter Coin.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Article 1 – Définition des termes</span>
            <span class="text">La signification des termes dans les éléments suivants des présentes Conditions sera telle que spécifiée dans chaque élément.</span>
            <span class="text">(1) « Contrat d'utilisation du service » désigne un contrat concernant l'utilisation du Service.</span>
            <span class="text">(2) « Utilisateur du service » désigne une personne qui a conclu un contrat d'utilisation du service avec notre société.</span>
            <span class="text">(3) « Informations sur le compte » désigne les informations relatives à l'utilisateur du service que l'utilisateur du service a enregistré auprès du service.</span>
            <span class="text">(4) « Coin » désigne une devise qui ne peut être utilisée que par notre société.</span>
            <span class="text">(5) Le « solde utilisé » est le solde des pièces détenues et disponibles pour être utilisées par l'utilisateur du service.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Article 2 – Monnaie</span>
            <span class="text">(1) Les utilisateurs du Service peuvent acheter des Coins qui peuvent être utilisés dans le Service en utilisant la méthode spécifiée par la Société et au prix indiqué par la Société dans le Service. En outre, la Société peut définir des unités d'achat, des méthodes de paiement, des périodes d'utilisation et d'autres conditions d'achat pour l'achat de Coins pour les utilisateurs du service, et les conditions d'achat définies et le montant payable, etc. seront publiés dans le Service ou les services exploités par la Société.</span>
            <span class="text">(2) Lorsqu'un utilisateur du service exprime son intention d'acheter une pièce en utilisant la méthode prescrite par la société, un contrat entre l'utilisateur du service et la société concernant l'achat de la pièce sera établi et le montant total de l'achat sera déterminé.</span>
            <span class="text">(3) Si l'utilisateur du service qui achète Coin est mineur, il doit obtenir le consentement d'un parent ou d'un tuteur avant d'acheter Coin.</span>
            <span class="text">(4) Si un mineur achète un Coin, la Société supposera que la personne détenant l'autorité parentale a consenti à l'achat du Coin.</span>
            <span class="text">(5) Le solde d'utilisation de l'utilisateur du service affiché dans le Service sera lié aux informations du compte et enregistré dans l'équipement de télécommunications utilisé pour fournir le Service et d'autres services exploités par la Société.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Article 3 – Utilisation du Coin</span>
            <span class="text">(1) La pièce peut être utilisée pour acheter nos produits.</span>
            <span class="text">(2) Les utilisateurs du service peuvent acquérir des produits fournis par la Société dans la limite du montant de leur solde Coin.</span>
            <span class="text">(3) Si un utilisateur du service utilise Coin pour acheter un produit auprès de la Société, le prix du produit sera déduit du solde Coin et le montant sera réputé avoir été payé.</span>
            <span class="text">Sauf indication contraire, les Coins accordés gratuitement par la Société aux utilisateurs du service au sein du Service seront consommés préférentiellement.</span>
            <span class="text">(4) Les utilisateurs du service peuvent vérifier leur solde de pièces au sein du service. De plus, les utilisateurs du service sont responsables de la gestion et du contrôle de l’augmentation et de la diminution des Coins.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Article 4 – Manipulation des pièces</span>
            <span class="text">(1) La Société accordera des Coins à l'Utilisateur conformément à la méthode déterminée par la Société lorsque l'Utilisateur achète des Coins dans le Service, lorsque la Société mène une campagne ou dans d'autres cas. L'unité d'achat des Coins, le prix, la période de validité et les autres conditions d'octroi des Coins seront déterminés par la Société et affichés sur le Service.</span>
            <span class="text">(2) La durée de validité du Coin est de 6 mois à compter de la date d'attribution du Coin.</span>
            <span class="text">(3) La Société ne remboursera pas les Coins acquis par l'Utilisateur, sauf si la loi l'exige. Dans le cas d'un remboursement de Coins basé sur les lois et réglementations, la méthode et les conditions de remboursement seront publiées séparément de la manière déterminée par la Société.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Article 5 – Interdiction de conversion en espèces, etc.</span>
            <span class="text">Concernant tout contenu acquis au sein de ce service, tout transfert, transfert, prêt, emprunt, etc. sous la forme de donner ou de recevoir de l'argent ou toute autre contrepartie du monde réel (y compris, mais sans s'y limiter, ce que l'on appelle RMT [échange en argent réel]), que ce soit directement, par l'intermédiaire d'un tiers, par une vente aux enchères sur Internet ou par d'autres moyens, est interdit.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Article 6 – Transfert de Coin, etc.</span>
            <span class="text">Les utilisateurs du service ne peuvent pas céder, prêter, offrir ou autrement transférer des pièces ou des produits à un tiers, ni mettre en gage ou autrement fixer une sûreté.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Article 7 - Suspension de l'achat et de l'utilisation des Coins, etc.</span>
            <span class="text">Si un utilisateur du service relève de l'une des situations suivantes, la Société peut prendre à l'encontre de l'utilisateur du service les mesures qu'elle juge appropriées (y compris, mais sans s'y limiter, la suspension de l'achat ou de l'utilisation de Coin).</span>
            <span class="text">(1) Si des pièces ou des produits sont obtenus ou utilisés par des moyens illégaux</span>
            <span class="text">(2) Si l'utilisateur du service viole les présentes conditions d'utilisation</span>
            <span class="text">(3) Dans d'autres cas où la Société détermine que l'utilisation du Service par l'Utilisateur du Service est inappropriée.</span>
          </div>
        </ShadowBoxTitleDescription>
        <ShadowBoxTitleDescription
          class="shadow-box-title-description"
          title=""
        >
          <div class="text-container">
            <span class="text">Créé le 28 février 2025</span>
          </div>
        </ShadowBoxTitleDescription>
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBoxTitleDescription from '@/components/molecules/ShadowBoxTitleDescription.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n_point_terms_of_service';

export default {
  name: 'TermsOfService',
  mixins: [t],

  components: {
    BaseTemplate,
    ShadowBoxTitleDescription,
    Title,
  },

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
  },

  created() {
    this.$store.dispatch('user/setCurrentUser', { token: 'yugi' });
  },
};
</script>

<style lang="scss" scoped>
.point-terms-of-service{
  width: 100%;
  max-width: 1000px;
  min-height: 100%;
  padding: 30px 20px 0px;
  margin: 0px auto;
  .point-terms-of-service-title{
    display: flex;
    justify-content: center;
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .scroll-container{
    width: 100%;
    margin-top: 30px;
    padding-bottom: 50px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .shadow-box-title-description{
      width: 100%;
      .text-container{
        display: flex;
        flex-direction: column;
        padding: 5px 5px 0px 5px;
        .text{
          font-family: $notoSans;
          font-size: 13px;
          line-height: 1.5;
          letter-spacing: 0.03em;
          a {
            color: black!important;
          }
          &.margin-top{
            margin-top: 10px;
          }
          &.one-line-space-top{
            margin-top: 1em;
          }
        }
      }
      & + .shadow-box-title-description{
        margin-top: 40px;
      }
    }
  }
}
</style>
